// extracted by mini-css-extract-plugin
export var activeDot = "_2z-c";
export var buttonContainer = "_2z-9";
export var channelButton = "_2z-a";
export var clickable = "_2z-d";
export var content = "_2z-0";
export var contentFull = "_2z-2";
export var contentThird = "_2z-1";
export var contentWrapper = "_2z-7";
export var description = "_2z-5";
export var heightShort = "_2z-f";
export var image = "_2z-3";
export var imageContainer = "_2z-4";
export var selectButton = "_2z-e";
export var spinnerContainer = "_2z-b";
export var titleContent = "_2z-8";
export var titleWrapper = "_2z-6";